import PagamentoLoteLotesComponent from "../../components/pagamento-lote/lotes/PagamentoLoteLotes";

export default function PagamentoLoteLotes() {
  return <PagamentoLoteLotesComponent />;
}
